{
  "learning-path": "Lärväg",
  "learning-path_plural": "Lärvägar",
  "path": "Lärväg",
  "path_plural": "Lärvägar",
  "events": "Händelser",
  "seminar": "Seminarie",
  "seminar_plural": "Seminarie",
  "survey": "Survey",
  "webinar": "Webbinarie",
  "section": "Section",
  "webinar_plural": "Webbinarie",
  "external": "Campus online",
  "external_plural": "Campus online",
  "user-generated": "Manuellt tillagd",
  "user-generated_plural": "Manuellt tillagda",
  "collection": "Galleri",
  "collection_plural": "Gallerier",
  "article": "Artikel",
  "article_plural": "Artiklar",
  "practicalAssessment": "Assessment",
  "video": "Video",
  "video_plural": "Videor",
  "resource": "Verktyg",
  "resource_plural": "Verktyg",
  "audio": "Audio",
  "audio_plural": "Audio",
  "e-learning": "E-lärande",
  "eLearning": "E-lärande",
  "e-learning_plural": "E-läranden",
  "online-learning": "On-demand-lärande",
  "onlineLearning": "On-demand-lärande",
  "online-learning_plural": "On-demand-läranden",
  "course": "Course",
  "course_plural": "Courses",
  "Course": "Kurs",
  "learning": "Lärande",
  "on-demand": "On Demand",
  "live": "Live",
  "profile": "Tilldelningsgrupp",
  "self-tracked": "Manuellt tillagd",
  "type": "Objekttyp",
  "other-learning-time": "Extern lärtid",
  "journey": "Journey",
  "other-learning-time_plural": "Extern lärtid",
  "live_event": "Live event",
  "liveEvent": "Live event",
  "live-event": "Live event"
}
